import styled from '@emotion/styled';

export const BusinessBuilderContainer = styled.div<{ navHeight: number }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: ${({ navHeight }) =>
    !navHeight ? `calc(90dvh)` : `calc(100dvh - ${navHeight}px)`};
  padding-bottom: 10px;
`;

export const Header = styled.div<{ isMobile: boolean }>`
  display: flex;
  justify-content: center;
  text-align: center;
  padding-top: 20px;
  padding-bottom: ${({ isMobile }) => (isMobile ? '0px' : '5px')};
`;

export const ChatWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
`;

export const StepperWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const GeneratingApplicationLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  padding-top: 100px;
`;

export const ErrorText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
  width: 100%;
`;

export const SmallErrorText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
  width: 100%;
  padding-top: 20px;
`;
